import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-slate text-white/60 py-12 text-center text-sm" data-id="element-56">
      <div className="max-w-6xl mx-auto px-4" data-id="element-57">
        <div className="font-heading text-2xl text-white mb-4" data-id="element-58">
          Competir Sin Miedo
        </div>
        <p className="mb-6 max-w-md mx-auto" data-id="element-59">
          Herramientas prácticas de fortaleza mental para futbolistas jóvenes y
          sus familias.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6 mb-8" data-id="element-60">
          <a href="#" className="hover:text-white transition-colors" data-id="element-61">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-62">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-63">
            Contacto
          </a>
        </div>

        <p data-id="element-64">
          &copy; {currentYear} Competir Sin Miedo. Todos los derechos
          reservados.
        </p>
        <p className="mt-2 text-xs opacity-50" data-id="element-65">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}